import { render, staticRenderFns } from "./Particles.vue?vue&type=template&id=0025b0c8&scoped=true"
import script from "./Particles.vue?vue&type=script&lang=js"
export * from "./Particles.vue?vue&type=script&lang=js"
import style0 from "./Particles.vue?vue&type=style&index=0&id=0025b0c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0025b0c8",
  null
  
)

export default component.exports